import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { userAtom } from '../../store/atoms';
import NotificationDropdown from '../NotificationDropdown/NotificationDropdown';
import styles from './UserSection.module.scss';
import { getUserDisplayNameWithDeleted, isUserDeleted } from '../../utils/userPresence';
import deletedUserUi from '../UserPresence/deletedUserUi.module.scss';

interface UserSectionProps {
  isMobile: boolean;
  /** Header’da (örn. New Project) üst bar aksiyonu varken mobilde isim yer açsın diye gizlenir */
  hideUsernameWhenTopBarActions?: boolean;
  onMobileDrawerClose?: () => void;
}

const UserSection: React.FC<UserSectionProps> = ({
  isMobile,
  hideUsernameWhenTopBarActions = false,
  onMobileDrawerClose,
}) => {
  const [user] = useAtom(userAtom);
  const navigate = useNavigate();

  if (!user) {
    return (
      <Button onClick={() => navigate('/login')} size={isMobile ? "small" : "middle"}>
        {!isMobile && "Login"}
      </Button>
    );
  }

  const openUserSettings = () => {
    onMobileDrawerClose?.();
    navigate('/settings');
  };

  return (
    <>
      <button
        type="button"
        className={`${styles.userName} ${isUserDeleted(user) ? deletedUserUi.nameDeleted : ''}${
          hideUsernameWhenTopBarActions && isMobile ? ` ${styles.userNameHiddenWhenTopBarActions}` : ''
        }`}
        onClick={openUserSettings}
      >
        {getUserDisplayNameWithDeleted(user, null)}
      </button>

      <NotificationDropdown 
        isMobile={isMobile}
        onMobileDrawerClose={onMobileDrawerClose}
      />
    </>
  );
};

export default UserSection; 